import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useUserPermissions } from '../hooks/useUserPermissions';

interface QuickBooksAdminRouteProps {
  children?: React.ReactNode;
}

/**
 * Route guard for QuickBooks admin pages
 * Requires the user to have 'quickbooks.admin', 'accounting.admin', or 'system.admin' permission
 * Redirects to the main admin dashboard if permission is missing
 */
export const QuickBooksAdminRoute: React.FC<QuickBooksAdminRouteProps> = ({ children }) => {
  const { hasPermission, isLoading } = useUserPermissions();

  // Show loading while checking permissions
  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '400px' }}>
        <CircularProgress />
      </Box>
    );
  }

  // Check for QuickBooks, Accounting admin, or System admin permission
  const hasQuickBooksPermission =
    hasPermission('quickbooks.admin') ||
    hasPermission('accounting.admin') ||
    hasPermission('system.admin');

  if (!hasQuickBooksPermission) {
    return <Navigate to="/admin/market-compass" replace />;
  }

  return <>{children || <Outlet />}</>;
};